(function () {
  'use strict';

  function editMyProfileController($scope, $log, $timeout, $rootScope, $location, $uibModal, $window,
      sessionData, profile, myProfileDataService, notifyService,
      mailRequestDataService, entityProfilePercentageCompleteCalculatorService,
      STATES_LIST) {

      var vm = this;
      vm.mode = 'Display';
      vm.sessionData = sessionData;
      vm.entity = profile;
      vm.entity.Attributes.forEach(function (attr) {
        attr.Mode = vm.mode;
      });

      vm.toggleEditMode = function () {
        vm.mode = vm.mode === 'Display' ? 'Editor' : 'Display';
        vm.entity.Attributes.forEach(function (attr) {
          attr.Mode = vm.mode;
        });
      };

      vm.entity.open = true;
      vm.statesList = STATES_LIST;
      vm.currentProfilePanelIndex = 0;
      vm.baseProfileCompletedPercentage = 30;
      vm.isProfileEditorVisible = true;

      vm.profilePanels = ['companyDetails', 'tellUs', 'attributes', 'card'];
      switch (vm.entity.ViewModelType) {
          case "AccountManager":
              vm.profilePanels.splice(vm.profilePanels.indexOf('tellUs'), 1);
              vm.profilePanels.splice(vm.profilePanels.indexOf('card'), 1);
              vm.workflowsUrl = "[BuildifyApiHost]/api/accountmanagers/workflows";
              break;
          case "InsuranceBroker":
              vm.workflowsUrl = "[BuildifyApiHost]/api/insurancebrokers/workflows";
              break;
          case "ProductProvider":
              vm.workflowsUrl = "[BuildifyApiHost]/api/productproviders/workflows";
              break;
          default:
              vm.workflowsUrl = "[BuildifyApiHost]/api/workflows";
      }

      if (vm.entity.Attributes.length === 0) {
          vm.profilePanels.splice(vm.profilePanels.indexOf('attributes'), 1);
      }

      vm.profilePanelCount = vm.profilePanels.length;
      vm.isProfileEditorVisible = false;
      vm.allowedLogoUploadFileExtensions = ['gif', 'jpg', 'jpeg', 'png', 'bmp', 'svg'];
      vm.updateErrors = null;
      vm.path = [];

      vm.goBack = function () {
        $window.history.back();
      }

      vm.simplePublish = function () {
          vm.entity.IsPublished = true;
          mailRequestDataService.sendPublishedUpdate({
              EntityId: vm.entityId
          });
          vm.updateEntityProfile();
          vm.updatePublishingState();
          vm.openPublishingAlert();
      }

      vm.simpleUnpublish = function () {
          vm.entity.IsPublished = false;
          vm.updateEntityProfile();
          vm.updatePublishingState();
          vm.openPublishingAlert('unpublished');
      }

      vm.premiumPublish = function () {
          if (vm.entity.IsPremiumAccount) {
              vm.entity.IsPublished = true;
              mailRequestDataService.sendPublishedUpdate({
                  EntityId: vm.entityId
              });
              vm.updateEntityProfile();
              vm.updatePublishingState();
          }
          vm.openPublishingAlert();
      }

      vm.publishActions = {
          'Self': {
              call: vm.simplePublish
          },
          'SelfAndAdmin': {
              call: vm.simplePublish
          },
          'Premium': {
              call: vm.premiumPublish
          }
      }

      vm.unpublishActions = {
          'Self': {
              call: vm.simpleUnpublish
          },
          'SelfAndAdmin': {
              call: vm.simpleUnpublish
          },
          'Premium': {
              call: vm.simpleUnpublish
          }
      }

      vm.updatePublishingState = function () {
          vm.isEntityPublishable = !vm.entity.IsPublished && vm.publishActions.hasOwnProperty(vm.entity.PublishingType);
          vm.isEntityUnpublishable = vm.entity.IsPublished && vm.publishActions.hasOwnProperty(vm.entity.PublishingType);
      }

      vm.updatePublishingState();

      vm.openPublishingAlert = function (state) {
          var modalInstance = $uibModal.open({
              templateUrl: 'publishEventModal',
              controller: 'entityPublishingModalController',
              resolve: {
                  publishingState: function () {
                      if (state === 'unpublished') {
                          return 'Unpublished'
                      } else if (vm.entity.PublishingType === 'Premium' && !vm.entity.IsPremiumAccount) {
                          return 'UpgradeRequired';
                      }

                      return 'Published';
                  },
                  entityId: function () {
                      return vm.entityId;
                  }
              }
          });

          return modalInstance.result.then(function () {});
      }

      vm.calculateProfileCompletedPercentage = function () {
          vm.profileCompletedPercentage = entityProfilePercentageCompleteCalculatorService.calculateProfileCompletedPercentage(vm.entity, vm.baseProfileCompletedPercentage);

          if (vm.profileCompletedPercentage === 100) {
              vm.profilePanelCount = 4;
          }

          return vm.profileCompletedPercentage;
      }

      vm.calculateProfileCompletedPercentage();

      vm.modelOptions = {
          updateOn: 'default blur',
          debounce: {
              "default": 300,
              "blur": 0
          }
      };

      // $timeout(function () {
      //     vm.myProfileForm = $scope.myProfileForm;
      //     $scope.$watch(
      //         function () {
      //             return {
      //                 dirty: vm.myProfileForm.$dirty,
      //                 valid: vm.myProfileForm.$valid
      //             }
      //         },
      //         function (newVal) {
      //             if (newVal.valid && newVal.dirty) {
      //                 // TODO: Hack to hangle checkbox-list not working with ng-modeloptions
      //                 $timeout(function () {
      //                     vm.updateEntityProfile();
      //                 }, 0);
      //             }
      //         },
      //         true);

      //     vm.adminEditsForm = $scope.adminEditsForm;
      //     $scope.$watch(
      //         function () {
      //             return {
      //                 dirty: vm.adminEditsForm.$dirty,
      //                 valid: vm.adminEditsForm.$valid
      //             }
      //         },
      //         function (newVal) {
      //             if (newVal.valid && newVal.dirty) {
      //                 // TODO: Hack to hangle checkbox-list not working with ng-modeloptions
      //                 $timeout(function () {
      //                     vm.updateAdminEdits();
      //                 }, 0);
      //             }
      //         },
      //         true);
      // }, 0);

      vm.change = function () {
          $log.debug('checklist changed');
      }

      $rootScope.$on('fileUploaded', function (event, args) {
          vm.entity.Logo = args.blobs[0];
          vm.updateEntityProfile(true);
          notifyService.notify('You updated your profile picture');
      });

      vm.updateEntityProfile = function (stayInEditMode) {
          if ($scope.myProfileForm.$valid) {
              vm.updateErrors = null;

              return myProfileDataService.updateMyProfile(angular.toJson(vm.entity)).then(
                  function (response) {
                      //notifyService.notify('Updated profile');
                      var newPct = vm.calculateProfileCompletedPercentage();
                      $rootScope.$emit('profilePercentageChanged', {
                        percentageComplete: newPct
                      });
                      $scope.myProfileForm.$setPristine();
                      if (!stayInEditMode) {
                        notifyService.notify('You updated your profile');
                        vm.toggleEditMode();
                      }
                  },
                  function (errorResponse) {
                      self.updateErrors = errorResponse.data;
                  });
          } else {
              self.errors = 'Form errors';
              notifyService.notify('There was an error saving your profile', true);
              return false;
          }
      };

      vm.tinymceOptions = {
          height: "300",
          menubar: false,
          statusbar: false,
          resize: false,
          plugins: [
              "advlist autolink link paste"
          ],
          advlist_bullet_styles: "disc",
          toolbar: "undo redo | bold italic | bullist | link",
          valid_elements: '*[*]',
          debounce: true
      };

      vm.setProfilePanel = function (index) {
          vm.currentProfilePanelIndex = index;
          vm.isProfileEditorVisible = true;
      }

      $rootScope.$on('toggleProfileEditor', function () {
          vm.isProfileEditorVisible = !vm.isProfileEditorVisible;
      });

      vm.toggleProfileEditor = function () {
          $rootScope.$broadcast('toggleProfileEditor');
      }

      vm.permissionMappingExists = function (item, list) {
          return list.find(function (listItem)
          {
              return listItem.Value === item && listItem.Selected;
          });
      };

      vm.permissionMappingToggle = function (item, list) {
          var matchingItem = list.find(function (listItem)
          {
              return listItem.Value === item ;
          });
          if (matchingItem)
          {
              matchingItem.Selected = !matchingItem.Selected;
          }

          vm.updateAdminEdits();
      };

      vm.updateAdminEdits = function () {
          if ($scope.adminEditsForm.$valid) {
              console.log(vm.entityAdminEdits);
              vm.updateAdminEditsErrors = null;

              return entityAdminEditsDataService.updateAdminEntityEdits(vm.entityId,
                  angular.toJson(vm.entityAdminEdits)).then(
                  function (response) {
                      $scope.adminEditsForm.$setPristine();
                  },
                  function (errorResponse) {
                      self.updateAdminEditsErrors = errorResponse.data;
                  });
          } else {
              self.errors = 'Form errors';
              return false;
          }
      };
  }

  editMyProfileController.$inject = [
      '$scope', '$log', '$timeout', '$rootScope', '$location', '$uibModal', '$window',
      'sessionData', 'profile', 'myProfileDataService', 'notifyService',
      'mailRequestDataService', 'entityProfilePercentageCompleteCalculatorService',
      'STATES_LIST'
  ];

  angular.module('ecap.dashboards').controller('editMyProfileController', editMyProfileController);
})();